const BackgroundStyle = 'BackgroundStyle';
const Policy = 'Policy';
const ProfileContentManagement = 'ProfileContentManagement';
const FeatureProducts = 'FeatureProducts';

const backgroundStyle = 'backgroundStyle';
const image = 'image';
const imageSetting = 'imageSetting';
const backgroundColor = 'title';
const primaryColor = 'primaryColor';
const tabColor = 'tabColor';
const textColor = 'textColor';

const policy = 'policy';
const items = 'items';
const linkTo = 'linkTo';
const title = 'title';

const profileContentManagement = 'profileContentManagement';
const myAddress = 'myAddress';
const subscriptionBuy = 'subscriptionBuy';
const thirdPartyLogin = 'thirdPartyLogin';
const voucher = 'voucher';

const featuredProducts = 'featuredProducts';
const titleTextColor = 'titleTextColor';

export {
  BackgroundStyle,
  Policy,
  ProfileContentManagement,
  FeatureProducts,
  backgroundStyle,
  image,
  imageSetting,
  backgroundColor,
  primaryColor,
  tabColor,
  textColor,
  policy,
  items,
  linkTo,
  title,
  profileContentManagement,
  myAddress,
  subscriptionBuy,
  thirdPartyLogin,
  voucher,
  featuredProducts,
  titleTextColor,
};
